function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("linearGradient", {
  id: "7dv5aw1ikc",
  x1: "35.1518576%",
  y1: "66.5050531%",
  x2: "101.499999%",
  y2: "-0.499999523%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#6A2D87"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#A93D69"
}));
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#7dv5aw1ikc)",
  d: "M11.99,2 C6.47,2 2,6.48 2,12 C2,17.52 6.47,22 11.99,22 C17.52,22 22,17.52 22,12 C22,6.48 17.52,2 11.99,2 L11.99,2 Z M12,4 C16.42,4 20,7.58 20,12 C20,16.42 16.42,20 12,20 C7.58,20 4,16.42 4,12 C4,7.58 7.58,4 12,4 Z M12.5,7 L11,7 L11,13 L16.25,16.15 L17,14.92 L12.5,12.25 L12.5,7 Z"
});
const SvgNewProductFreeTrialClock = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNewProductFreeTrialClock, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/new-product-free-trial-clock.e121b210.svg";
export { ForwardRef as ReactComponent };